import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const InboundConsolidationItemKinds = [
  "product",
  "return",
  "unknown",
] as const;
export type InboundConsolidationItemKind =
  (typeof InboundConsolidationItemKinds)[number];

export const InboundConsolidationItemStatuses = [
  "eligible",
  "registered",
  "partially_packed",
  "packed",
] as const;
export type InboundConsolidationItemStatus =
  (typeof InboundConsolidationItemStatuses)[number];

const inboundConsolidationItemSchema_ = z.object({
  inventoryItemId: z.string(),
  kind: z.enum(InboundConsolidationItemKinds),
  productTitle: z.string().nullable(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  returnOrderName: z.string().nullable(),
  returnHref: z.string().nullable(),
  inWarehouseSince: z.date(),
  storageLocationNames: z.array(z.string()),
  cartonNumbers: z.array(z.number()),
  disposition: z.string().nullable(),
  status: z.enum(InboundConsolidationItemStatuses),
});
export const inboundConsolidationItemSchema: z.ZodType<InboundConsolidationItem> =
  inboundConsolidationItemSchema_;
export interface InboundConsolidationItem extends z.infer<
  typeof inboundConsolidationItemSchema_
> {}

export const listInboundConsolidationItems = unaryRpc({
  name: "listInboundConsolidationItems" as const,
  input: z.object({
    consolidationId: z.string(),
    cursor: z.string().optional(),
    includeTotal: z.boolean().default(false),
    pageSize: z.number().int().min(1).max(200).default(25),
  }),
  output: z.object({
    items: z.array(inboundConsolidationItemSchema),
    nextCursor: z.string().nullable(),
    totalCount: z.number().int().nullable(),
  }),
});
